// File#: _2_flexi-header
// Usage: codyhouse.co/license
$(document).ready(function() {
  // Use a small delay to ensure DOM is fully ready
  setTimeout(function() {
    initFlexiHeader();
  }, 100);
});

// Also try on window load in case DOM ready fires too early
window.addEventListener('load', function() {
  setTimeout(function() {
    initFlexiHeader();
  }, 50);
});

function initFlexiHeader() {
  var flexHeader = document.getElementsByClassName('js-f-header');
  if(flexHeader.length > 0) {
    var menuTrigger = flexHeader[0].getElementsByClassName('js-anim-menu-btn')[0],
      firstFocusableElement = getMenuFirstFocusable();

    // we'll use these to store the node that needs to receive focus when the mobile menu is closed 
    var focusMenu = false;

    if(menuTrigger && !menuTrigger.hasAttribute('data-flexi-header-handled')) {
      // Listen for the custom event
    menuTrigger.addEventListener('anim-menu-btn-clicked', function(event){ // toggle menu visibility an small devices
        // Find nav in the same header as the button
        var nav = flexHeader[0].getElementsByClassName('f-header__nav')[0];
        if(nav) {
          if(typeof Util !== 'undefined' && Util.toggleClass) {
            Util.toggleClass(nav, 'f-header__nav--is-visible', event.detail);
          } else {
            // Fallback if Util is not available
            if(event.detail) {
              nav.classList.add('f-header__nav--is-visible');
            } else {
              nav.classList.remove('f-header__nav--is-visible');
            }
          }
      menuTrigger.setAttribute('aria-expanded', event.detail);
          if(event.detail && firstFocusableElement) firstFocusableElement.focus(); // move focus to first focusable element
      else if(focusMenu) {
        focusMenu.focus();
        focusMenu = false;
      }
        }
    });
      
      // Also add a direct click listener as a fallback
      // This checks the button state after the anim-menu-btn component has toggled it
      menuTrigger.addEventListener('click', function(event) {
        setTimeout(function() {
          var nav = flexHeader[0].getElementsByClassName('f-header__nav')[0];
          if(nav) {
            // Check button state (anim-menu-btn--state-b means menu is open)
            var buttonIsOpen = menuTrigger.classList.contains('anim-menu-btn--state-b');
            var navIsVisible = nav.classList.contains('f-header__nav--is-visible');
            
            // Sync nav visibility with button state
            if(buttonIsOpen && !navIsVisible) {
              // Button says open but nav is closed - open it
              if(typeof Util !== 'undefined' && Util.toggleClass) {
                Util.toggleClass(nav, 'f-header__nav--is-visible', true);
              } else {
                nav.classList.add('f-header__nav--is-visible');
              }
              menuTrigger.setAttribute('aria-expanded', 'true');
            } else if(!buttonIsOpen && navIsVisible) {
              // Button says closed but nav is open - close it
              if(typeof Util !== 'undefined' && Util.toggleClass) {
                Util.toggleClass(nav, 'f-header__nav--is-visible', false);
              } else {
                nav.classList.remove('f-header__nav--is-visible');
              }
              menuTrigger.setAttribute('aria-expanded', 'false');
            }
          }
        }, 50); // Wait a bit for anim-menu-btn to update button state
      });
      
      menuTrigger.setAttribute('data-flexi-header-handled', 'true');
    }

    // listen for key events
    if(menuTrigger) {
    window.addEventListener('keyup', function(event){
      // listen for esc key
      if( (event.keyCode && event.keyCode == 27) || (event.key && event.key.toLowerCase() == 'escape' )) {
        // close navigation on mobile if open
        if(menuTrigger.getAttribute('aria-expanded') == 'true' && isVisible(menuTrigger)) {
          focusMenu = menuTrigger; // move focus to menu trigger when menu is close
          menuTrigger.click();
        }
      }
      // listen for tab key
      if( (event.keyCode && event.keyCode == 9) || (event.key && event.key.toLowerCase() == 'tab' )) {
        // close navigation on mobile if open when nav loses focus
        if(menuTrigger.getAttribute('aria-expanded') == 'true' && isVisible(menuTrigger) && !document.activeElement.closest('.js-f-header')) menuTrigger.click();
      }
    });
    }

    function getMenuFirstFocusable() {
      var nav = flexHeader[0].getElementsByClassName('f-header__nav')[0];
      if(!nav) return false;
      var focusableEle = nav.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary'),
        firstFocusable = false;
      for(var i = 0; i < focusableEle.length; i++) {
        if( focusableEle[i].offsetWidth || focusableEle[i].offsetHeight || focusableEle[i].getClientRects().length ) {
          firstFocusable = focusableEle[i];
          break;
        }
      }

      return firstFocusable;
    };
    
    function isVisible(element) {
      return (element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    };
  }
  
  // Fallback: Handle anim-menu-btn-clicked events even without js-f-header structure
  // This is useful for headers that use js-anim-menu-btn but don't have the full flexi-header structure
  var allMenuButtons = document.getElementsByClassName('js-anim-menu-btn');
  for(var i = 0; i < allMenuButtons.length; i++) {
    (function(btn) {
      // Only add listener if not already handled by flexi-header above
      if(!btn.hasAttribute('data-flexi-header-handled')) {
        btn.addEventListener('anim-menu-btn-clicked', function(event) {
          // Use the button that dispatched the event, not event.target (which might be a child element)
          var button = event.currentTarget || btn;
          // Try to find a nav element to toggle - could be .nav, .f-header__nav, or other
          var header = button.closest('header');
          if(header) {
            var nav = header.querySelector('.nav, .f-header__nav, nav[role="navigation"]');
            if(nav) {
              // Toggle expanded class or is-visible class
              if(nav.classList.contains('nav')) {
                nav.classList.toggle('expanded', event.detail);
                var navToggle = header.querySelector('.nav-toggle');
                if(navToggle) navToggle.classList.toggle('expanded', event.detail);
              } else if(nav.classList.contains('f-header__nav')) {
                if(typeof Util !== 'undefined' && Util.toggleClass) {
                  Util.toggleClass(nav, 'f-header__nav--is-visible', event.detail);
                } else {
                  // Fallback if Util is not available
                  if(event.detail) {
                    nav.classList.add('f-header__nav--is-visible');
                  } else {
                    nav.classList.remove('f-header__nav--is-visible');
                  }
                }
              }
              button.setAttribute('aria-expanded', event.detail);
            }
          }
        });
        btn.setAttribute('data-flexi-header-handled', 'true');
      }
    })(allMenuButtons[i]);
  }
}